<template>
  <div class="project-header">
    <div ref="headerFill" class="header-fill" :style="style">
      <header>
        <site-title :textColor="'#fff'" :textDelay="1"/>
        <hgroup>
          <slot name="projectTitle" />
          <ul ref="headerInfo">
            <li>
              <u>Year</u>
              <slot name="year" />
            </li>
            <li>
              <u>Team</u>
              <slot name="team" />
            </li>
            <li>
              <u>Participation</u>
              <slot name="participation" />
            </li>
          </ul>
        </hgroup>
        <img src="/static/image/icon-arrow-down.svg" alt="Scroll down" width="20" height="14" class="icon-down" ref="iconDown">
      </header>
    </div><!-- .header-fill -->
  </div>
</template>

<script>
  import SiteTitle from '@/components/SiteTitle.vue'

  import {TimelineMax, TweenMax, Power3, Power4} from 'gsap'
  import SplitText from '#/script/SplitText'

  export default {
    name: 'project-header',
    props: ['bgColor'],
    components: {
      'site-title': SiteTitle
    },
    data () {
      return {
        headerTimeline: null
      }
    },
    computed: {
      style () {
        return 'background-color: ' + this.bgColor
      }
    },
    beforeMount () {
      this.headerTimeline = new TimelineMax({paused: true})
    },
    mounted () {
      // Header
      this.headerTimeline.fromTo(this.$refs.headerFill, 1.4, {height: '0%'}, {height: '100%', ease: Power4.easeInOut, force3D: true}, '+=0.5')

      // Project info list
      const headerInfoList = []

      this.$refs.headerInfo.childNodes.forEach(listItem => {
        if (listItem.nodeType === Node.ELEMENT_NODE) {
          headerInfoList.push(listItem)
        }
      })
      this.headerTimeline.staggerFromTo(headerInfoList, 1, {opacity: 0, y: 30}, {opacity: 1, y: 0, ease: Power3.easeOut}, 0.04)

      // Icon down
      this.headerTimeline.fromTo(this.$refs.iconDown, 1, {y: -20, opacity: 0}, {y: 0, opacity: 1, ease: Power3.easeOut}, '-=0.5')

      this.headerTimeline.restart()
    },
    updated () {
      // Project title
      const projectTitleSplit = new SplitText(this.$parent.$refs.projectTitle, {type: 'words'})
      TweenMax.staggerFrom(
        projectTitleSplit.words,
        1,
        {
          y: 100,
          ease: Power3.easeOut,
          delay: 1.2,
          onComplete: () => {
            projectTitleSplit.revert()
          }
        },
        0.1
      )
    }
  }
</script>

<style lang="scss" scoped>

  .project-header {
    height: 90vh;
    min-height: 600px;
    background-color: #fff;

    @include device(mobile) {
      min-height: 400px;
    }
  }

  .header-fill {
    height: 100%;
    overflow: hidden;

    @include device(laptop) {
      padding: 0 60px;
    }

    @include device(mobile) {
      padding: 0 20px;
    }
  }

  header {
    width: 100%;
    max-width: $size-max-width;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    & h1, & h2, & li {
      color: #fff;
      overflow: hidden;
    }
  }

  hgroup {
    & h2 {
      font-weight: 500;
      margin-bottom: 60px;

      @include device(mobile) {
        margin-top: 50px;
        margin-bottom: 50px; 
      }
    }

    & ul {
      & li {
        font-size: 0.9rem;
        line-height: 2rem;

        @include device(mobile) {
          margin-bottom: 1.5rem;
          line-height: 1.5rem;
        }
      }
    }
    
    & u {
      display: inline-block;
      font-weight: 500;
      text-decoration: none;
      min-width: 150px;

      @include device(mobile) {
        display: block;
      }
    }
  
    & i {
      display: inline-block;
      font-style: normal;
      opacity: 0.8;
    }
  }

  .icon-down {
    margin: 30px auto;
  }

</style>


// WEBPACK FOOTER //
// src/components/ProjectHeader.vue